import React, { useMemo } from "react";

import { Colors, FlexBox } from "@brg/ui";
// import { FontSizes } from "../../constants/theme";
import styled from "styled-components";
import { extractor } from "./blocks/ColoredBlock";
import { LayoutConst } from "core";

const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    place-items: flex-end;
    flex-flow: column;
    gap: 4px;
`;

const AuthorName = styled.div`
    font-style: Italic;
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 15px;
        line-height: 20px;
    }
`;

const SourceLink = styled.a`
    font-style: Italic;
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
    text-decoration: underline;
    color: ${Colors.galBlack47} !important;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 15px;
        line-height: 20px;
    }
    
    &:hover {
        color: ${Colors.galBlack21} !important;
    };
`;


export const QuoteInfoComponent = ({ post }: { post: any}) => {

    const quoteData = useMemo(() => {
        return extractor(post?.additionalInfo, 'quoteData', null)
    }, [post])

    const { author, sourceText, sourceLink } = useMemo(() => {
        if (quoteData) {
            const author = quoteData?.author || ''
            const sourceText = quoteData?.sourceText || ''
            const sourceLink = quoteData?.sourceLink || ''
    
            return {
                author,
                sourceText,
                sourceLink
            }
        }

        return {
            author: '',
            sourceText: '',
            sourceLink: ''
        }

    } , [post, quoteData])

    const sourceComponent = useMemo(() => {
        if (!quoteData) return <div></div>
        if (sourceLink && sourceText) {
            return <SourceLink href={sourceLink} target="_blank">{sourceText}</SourceLink>
        }
        else if (!sourceLink) {
            return <AuthorName>{sourceText}</AuthorName>
        } 

        return <div></div>
    } , [sourceText, sourceLink])

    if (post?.style !== 'quote' || !post) {
        return null;
    }


    return (
        <Container>
            <AuthorName>{author}</AuthorName>
            {sourceComponent}
        </Container>
    )
}import React, { useMemo } from "react";

import { Colors, FlexBox } from "@brg/ui";
// import { FontSizes } from "../../constants/theme";
import styled from "styled-components";
import { extractor } from "./blocks/ColoredBlock";
import { LayoutConst } from "core";

const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    place-items: flex-end;
    flex-flow: column;
    gap: 4px;
`;

const AuthorName = styled.div`
    font-style: Italic;
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 15px;
        line-height: 20px;
    }
`;

const SourceLink = styled.a`
    font-style: Italic;
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
    text-decoration: underline;
    color: ${Colors.galBlack47} !important;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 15px;
        line-height: 20px;
    }
    
    &:hover {
        color: ${Colors.galBlack21} !important;
    };
`;


export const QuoteInfoComponent = ({ post }: { post: any}) => {

    const quoteData = useMemo(() => {
        return extractor(post?.additionalInfo, 'quoteData', null)
    }, [post])

    const { author, sourceText, sourceLink } = useMemo(() => {
        if (quoteData) {
            const author = quoteData?.author || ''
            const sourceText = quoteData?.sourceText || ''
            const sourceLink = quoteData?.sourceLink || ''
    
            return {
                author,
                sourceText,
                sourceLink
            }
        }

        return {
            author: '',
            sourceText: '',
            sourceLink: ''
        }

    } , [post, quoteData])

    const sourceComponent = useMemo(() => {
        if (!quoteData) return <div></div>
        if (sourceLink && sourceText) {
            return <SourceLink href={sourceLink} target="_blank">{sourceText}</SourceLink>
        }
        else if (!sourceLink) {
            return <AuthorName>{sourceText}</AuthorName>
        } 

        return <div></div>
    } , [sourceText, sourceLink])

    if (post?.style !== 'quote' || !post) {
        return null;
    }


    return (
        <Container>
            <AuthorName>{author}</AuthorName>
            {sourceComponent}
        </Container>
    )
}